import Breadcrumbs, { getCrumbs } from '../common/Breadcrumbs';
import SearchPeerForm from '../includes/search/SearchPeerForm';
import { useLocation, useNavigate } from 'react-router';

const SearchPeer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Grab breadcrumb trail from the current location
  const passedCrumbs = location.state?.breadCrumbs || [];

  // Create a breadcrumb entry for this page
  const currentCrumb = {
    title: 'search peer',
    url: location.pathname,
    params: location.search,
  };

  const breadCrumbs = getCrumbs(passedCrumbs, currentCrumb, 'SearchPeer');

  const history = {
    push: navigate,
  };

  return (
    <div className="ContactPage">
      <Breadcrumbs crumbs={breadCrumbs} />
      <SearchPeerForm history={history} breadCrumbs={breadCrumbs} />
    </div>
  );
};

export default SearchPeer;
